"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _immutable = require("immutable");
var _stringHelper = require("../helpers/stringHelper.js");
/* Example Options:
const options = {
  fetched: true, // also updates synced attribute unless options.synced is explicitly set
  synced: true
};
*/
var Factory = /*#__PURE__*/function () {
  function Factory(json) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Factory);
    if (!this.constructor.jsonType) throw new Error("Factory '".concat(this.constructor.name, "' must define jsonType"));
    this.constructor.validateJSON(json);
    var factory = (0, _immutable.Map)({
      id: parseInt(json.id) || null
    });
    return this.constructor.update(factory, json, options);
  }
  _createClass(Factory, null, [{
    key: "getJsonTypePlural",
    value:
    // Child classes must define jsonType

    // jsonTypePlural can be overriden by defining it in the child Factory class
    function getJsonTypePlural() {
      return this.jsonTypePlural || this.jsonType + 's';
    }
  }, {
    key: "validateJSON",
    value: function validateJSON(json) {
      if (!json.id || json.id < 0) throw new Error("ID is required to create a new ".concat(this.constructor.name));
    }
  }, {
    key: "update",
    value: function update(state, json) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!json.attributes) json.attributes = {};
      if (!json.relationships) json.relationships = {};
      var result = {};

      // Extract Attributes
      var defaults = this.defaults;
      Object.keys(defaults).forEach(function (key) {
        if (json.attributes && Object.prototype.hasOwnProperty.call(json.attributes, key) && json.attributes[key] !== null) {
          result[key] = json.attributes[key];
        } else if (state.get(key) === undefined) {
          result[key] = defaults[key];
        }
      });

      // Extract Relationship IDs
      this.belongsTo.forEach(function (recordType) {
        if (json.relationships && json.relationships[recordType] && json.relationships[recordType].data) {
          result["".concat(recordType, "_id")] = parseInt(json.relationships[recordType].data.id);
        } else if (state.get("".concat(recordType, "_id")) === undefined) {
          result["".concat(recordType, "_id")] = 0;
        }
      });
      this.hasMany.forEach(function (recordType) {
        var recordTypePlural = (0, _stringHelper.pluralize)(recordType);
        if (json.relationships && json.relationships[recordTypePlural] && json.relationships[recordTypePlural].data && Array.isArray(json.relationships[recordTypePlural].data)) {
          var recordIds = json.relationships[recordTypePlural].data.filter(function (record) {
            return parseInt(record.id);
          }).map(function (record) {
            return parseInt(record.id);
          });
          result["".concat(recordType, "_ids")] = new _immutable.Set(recordIds);
        } else if (state.get("".concat(recordType, "_ids")) === undefined) {
          result["".concat(recordType, "_ids")] = new _immutable.Set([]);
        }
      });

      // Update State with extracted Attributes and Relationship IDs
      var newState = state.merge(result);

      // Perform afterUpdate() from child Factory classes
      newState = this.afterUpdate(newState, json);

      // Update the created_at attribute
      if (json.attributes && json.attributes.created_at) {
        newState = newState.set('created_at', new Date(json.attributes.created_at).getTime());
      } else if (newState.get('created_at') === undefined) {
        newState = newState.set('created_at', 0);
      }

      // Update the fetched_at attribute unless options.fetched = false
      if (options.fetched === undefined || options.fetched) {
        newState = newState.set('fetched_at', new Date().getTime()).set('synced', options.synced !== undefined ? !!options.synced : true);
        if (json.attributes && json.attributes.updated_at) {
          newState = newState.set('updated_at', new Date(json.attributes.updated_at).getTime());
        } else {
          newState = newState.set('updated_at', 0);
        }
      } else {
        if (newState.get('fetched_at') === undefined) {
          newState = newState.set('fetched_at', null);
        }
        newState = newState.set('synced', options.synced !== undefined ? !!options.synced : false).set('updated_at', new Date().getTime());
      }
      return newState;
    }

    // Overrideable Functions:
  }, {
    key: "defaults",
    get: function get() {
      return {};
    }
  }, {
    key: "belongsTo",
    get: function get() {
      return [];
    }
  }, {
    key: "hasMany",
    get: function get() {
      return [];
    }
  }, {
    key: "afterUpdate",
    value: function afterUpdate(state, json) {
      return state;
    }
  }, {
    key: "helperFunctions",
    get: function get() {
      return {};
    }
  }]);
  return Factory;
}();
exports.default = Factory;
Factory.jsonType = '';